import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Programs } from "@/components/Programs";
import { Housing } from "@/components/Housing";
import { Apply } from "@/components/Apply";
import { Contact, Footer } from "@/components/Contact";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-[#F9F9F8]">
      <Navbar />
      <Hero />
      <About />
      <Programs />
      <Housing />
      <Apply />
      <Contact />
      <Footer />
    </div>
  );
}
